import { render, staticRenderFns } from "./ConfigTag.vue?vue&type=template&id=7c2efbd2&scoped=true"
import script from "./ConfigTag.vue?vue&type=script&lang=js"
export * from "./ConfigTag.vue?vue&type=script&lang=js"
import style0 from "./ConfigTag.vue?vue&type=style&index=0&id=7c2efbd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2efbd2",
  null
  
)

export default component.exports